<template>
  <div
    ref="container"
    :class="displayClass">
    <LinkNormal
      as="button"
      type="button"
      :class="btnClass"
      :id="id"
      ref="reference"
      @click="() => (isOpen = !isOpen)"
      aria-haspopup="true"
      :aria-expanded="isOpen ? 'true' : 'false'">
      <slot name="button">What&rsquo;s this?</slot>
    </LinkNormal>

    <Teleport to="#popovers">
      <transition
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated animate__fadeOut animate__faster">
        <div
          ref="floating"
          v-if="isOpen"
          :aria-labelledby="id"
          :style="floatingStyles"
          class="z-1060 w-max max-w-lg rounded bg-black/90 px-4 py-2 text-white">
          <slot></slot>
        </div>
      </transition>
    </Teleport>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, useId } from 'vue';
import { useFloating, autoUpdate, flip, shift, offset } from '@floating-ui/vue';
import LinkNormal from '@/components/links/LinkNormal.vue';

defineProps({
  btnClass: {
    type: String,
  },
  displayClass: {
    type: String,
    default: 'inline-block',
  },
});

let id = useId();
let isOpen = ref(false);

// FLOATING UI CONFIG

// template refs
let container = ref(null);
let reference = ref(null);
let floating = ref(null);

let { floatingStyles } = useFloating(reference, floating, {
  whileElementsMounted: autoUpdate,
  placement: 'right',
  middleware: [offset(8), flip(), shift()],
});

// CLOSE LISTENERS
onMounted(() => {
  document.addEventListener('keydown', escapeListener);
  document.addEventListener('click', outsideClickListener);
});

onUnmounted(() => {
  document.removeEventListener('keydown', escapeListener);
  document.removeEventListener('click', outsideClickListener);
});

function escapeListener(event) {
  if (event.key === 'Escape' || event.key === 'Esc') {
    isOpen.value = false;
  }
}

function outsideClickListener(event) {
  if (container.value?.contains(event.target)) {
    return;
  }

  if (floating.value?.contains(event.target)) {
    return;
  }

  isOpen.value = false;
}
</script>
